import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from 'react';

interface ILicenciamentosFiltroContextData {
  dataFinal: string;
  setDataFinal: (value: string) => void;
  clearDataFinal: () => void;
  pesquisa: string;
  setPesquisa: (value: string) => void;
  clearPesquisa: () => void;
  clearAllFilters: () => void;
  isFiltered: boolean;
}

const STORAGE_KEY_DATA_FINAL = 'licenciamentos.dataFinal';
const STORAGE_KEY_PESQUISA = 'licenciamentos.pesquisa';

const LicenciamentosFiltroContext = createContext<ILicenciamentosFiltroContextData>({
  dataFinal: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setDataFinal: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  clearDataFinal: () => {},
  pesquisa: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setPesquisa: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  clearPesquisa: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  clearAllFilters: () => {},
  isFiltered: false,
});

export const LicenciamentosFiltroProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dataFinal, setDataFinalState] = useState<string>(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY_DATA_FINAL);
      return v || '';
    } catch (e) {
      return '';
    }
  });

  const [pesquisa, setPesquisaState] = useState<string>(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY_PESQUISA);
      return v || '';
    } catch (e) {
      return '';
    }
  });

  useEffect(() => {
    try {
      if (dataFinal) localStorage.setItem(STORAGE_KEY_DATA_FINAL, dataFinal);
      else localStorage.removeItem(STORAGE_KEY_DATA_FINAL);
    } catch (e) {
      // ignore storage errors
    }
  }, [dataFinal]);

  useEffect(() => {
    try {
      if (pesquisa) localStorage.setItem(STORAGE_KEY_PESQUISA, pesquisa);
      else localStorage.removeItem(STORAGE_KEY_PESQUISA);
    } catch (e) {
      // ignore storage errors
    }
  }, [pesquisa]);

  const setDataFinal = useCallback((value: string) => setDataFinalState(value), []);
  const clearDataFinal = useCallback(() => setDataFinalState(''), []);
  const setPesquisa = useCallback((value: string) => setPesquisaState(value), []);
  const clearPesquisa = useCallback(() => setPesquisaState(''), []);
  const clearAllFilters = useCallback(() => {
    setDataFinalState('');
    setPesquisaState('');
  }, []);

  const value = useMemo(() => ({
    dataFinal,
    setDataFinal,
    clearDataFinal,
    pesquisa,
    setPesquisa,
    clearPesquisa,
    clearAllFilters,
    isFiltered: Boolean(dataFinal || pesquisa),
  }), [dataFinal, pesquisa, setDataFinal, clearDataFinal, setPesquisa, clearPesquisa, clearAllFilters]);

  return (
    <LicenciamentosFiltroContext.Provider value={value}>
      {children}
    </LicenciamentosFiltroContext.Provider>
  );
};

export const useLicenciamentosFiltro = () => useContext(LicenciamentosFiltroContext);

export default LicenciamentosFiltroContext;
